export enum DTC_EVENTS {
    CLICK_SIGNIN = 'CLICK_SIGNIN',
    CLICK_SIGNUP = 'CLICK_SIGNUP',
    CLICK_MVPD = 'CLICK_MVPD',
    CLICK_FORGOT_PASSWORD = 'CLICK_FORGOT_PASSWORD',
}
